export default {
  global: {
    list: {
      title: "Lista de {name}",
    },
    view: {
      title: "Datos de {name}",
    },
    add: {
      title: ({ plural, named }) => plural([`Añadir un ${named("name")}`, `Añadir una ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} añadido correctamente`, `${named("name")} añadida correctamente`]),
    },
    accept: {
      title: ({ plural, named }) => plural([`Aceptar  un ${named("name")}`, `Aceptar  una ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} aceptado correctamente`, `${named("name")} aceptada correctamente`]),
    },
    decline: {
      title: ({ plural, named }) => plural([`Declinar  un ${named("name")}`, `Declinar  una ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} declinado correctamente`, `${named("name")} declinada correctamente`]),
    },
    edit: {
      title: ({ plural, named }) =>
        plural([`Modificar ${named("name")}`, `Modificar ${named("name")}`, `Modificar ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} modificado correctamente`, `${named("name")} modificada correctamente`]),
    },
    unactive: {
      title: ({ plural, named }) =>
        plural([`Desactivar el ${named("name")}`, `Desactivar un ${named("name")}`, `Desactivar una ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `¿Está seguro de que desea desactivar este ${named("name")}?`,
          `¿Está seguro de que desea desactivar esta ${named("name")}?`,
          `¿Está seguro de que desea desactivar ${named("name")}?`,
        ]),
      success: ({ plural, named }) =>
        plural([`¡${named("name")} desactivado exitosamente!`, `¡${named("name")} desactivada exitosamente!`]),
    },
    regenerate: {
      errors: "Error durante la regeneración",
      title: ({ plural, named }) => plural([`Regenerar un ${named("name")}`, `Regenerar una ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`¡${named("name")} regenerado con éxito!`, `¡${named("name")} regenerada con éxito!`]),
    },
    active: {
      title: ({ plural, named }) =>
        plural([`Activar ${named("name")}`, `Activar ${named("name")}`, `Activar ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `¿Confirma que quiere activar este ${named("name")}?`,
          `¿Confirma que quiere activar esta ${named("name")}?`,
          `¿Confirma que quiere activar ${named("name")}?`,
        ]),
      success: ({ plural, named }) =>
        plural([`${named("name")} activado correctamente !`, `${named("name")} activado correctamente !`]),
    },
    import: {
      errors: "Su archivo contiene errores. Corríjalos y repita la importación",
      title: "Importar {name}",
      error: "Error en línea {line}, columna {column}:",
      success: ({ plural, named }) =>
        plural([`${named("name")} importados correctamente`, `${named("name")} importadas correctamente`]),
    },
    ypareo: {
      title: "Última sincronización: {date}",
      title_failure: "Error de sincronización. Último intento realizado el: {date}",
    },
    export: {
      title: "Exportar {name}",
      title_singular: "Exportar {name}",
      title_alone: "Exportar",
      success: ({ plural, named }) =>
        plural([`${named("name")} exportados correctamente`, `${named("name")} exportadas correctamente`]),
    },
    update: {
      title: "Completar {name}",
      success: "{name} completado correctamente",
    },
    search: {
      title: "Buscar {name}",
      reset_filters: "Restablecer los filtros",
    },
    sort: {
      success: "Orden de {name} actualizado correctamente",
    },
    download: {
      success: "{name} descargado correctamente",
      title: "Descargar {name}",
      done: "Descarga completada",
      error: "Se ha producido un error durante la descarga",
    },
    move: {
      success: ({ plural, named }) =>
        plural([`${named("name")} desplazado correctamente`, `${named("name")} desplazada correctamente`]),
    },
    copy: {
      success: ({ plural, named }) =>
        plural([`${named("name")} duplicado correctamente`, `${named("name")} duplicada correctamente`]),
      title: ({ plural, named }) => plural([`Duplicar este ${named("name")}`, `Duplicar esta ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `¿Confirma que quiere duplicar este ${named("name")}?`,
          `¿Confirma que quiere duplicar esta ${named("name")}?`,
        ]),
    },
    empty: {
      title: ({ plural, named }) =>
        plural([
          `Todavía no hay ${named("name1")} en esta ${named("name2")}. Haga clic en + para añadir una`,
          `Todavía no hay ${named("name1")} en esta ${named("name2")}. Haga clic en + para añadir uno`,
          `Todavía no hay ${named("name1")} en esta ${named("name2")}. Haga clic en + para añadir una`,
        ]),
      dashboard: "Todavía no hay {name}",
      no_data_available: "Ningún dato disponible",
    },
    delete: {
      title_alone: "Eliminar",
      title: ({ plural, named }) =>
        plural([`Eliminar ${named("name")}`, `Eliminar un ${named("name")}`, `Eliminar una ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `¿Confirma que quiere eliminar un ${named("name")}?`,
          `¿Confirma que quiere eliminar una ${named("name")}?`,
          `¿Confirma que quiere eliminar ${named("name")}?`,
        ]),
      success: ({ plural, named }) =>
        plural([
          `${named("name")} eliminado correctamente`,
          `${named("name")} eliminada correctamente`,
          `${named("name")} eliminados correctamente`,
          `${named("name")} eliminadas correctamente`,
        ]),
    },
    valid: {
      title: ({ plural, named }) =>
        plural([`Validar ${named("name")}`, `Validar ${named("name")}`, `Validar ${named("name")}`]),
    },
    unvalid: {
      title: ({ plural, named }) =>
        plural([`Invalidar ${named("name")}`, `Invalidar ${named("name")}`, `Invalidar ${named("name")}`]),
    },
    opened: {
      title: ({ gender }) => gender(["Abierto", "Abierta", "Abiertos", "Abiertas"]),
    },
    closed: {
      title: ({ gender }) => gender(["Cerrado", "Cerrada", "Cerrados", "Cerradas"]),
    },

    label: {
      name: "Nombre",
      date: "Fecha",
      triads: "Trinomios",
      trainings: "Formaciones",
    },
    actions: {
      title: "Acciones",
      empty: "No hay ninguna acción disponible de momento",
    },
    see_more: "Ver más...",
    see_less: "Ver menos...",
    see_detail: "Mostrar/Ocultar detalles",
    collapse_show: "Mostrar",
    collapse_reduce: "Reducir",
    close: "Cerrar",
    duration: "Duración",
    period: "Periodo",
    show_hide_actions: "Mostrar/ocultar las acciones",
    visible: "Visible",
    visible_by: "Visible para",
    hidden: "Invisible",
    send: "Enviar",
    send_mail: "Enviar un correo",
    send_opco: "Enviar al OPCO",
    valid_file: "Validar el expediente",
    language: {
      change: "Cambiar de idioma ({language})",
      french: "Francés",
      english: "Inglés",
      spanish: "Español",
      german: "Alemán",
    },
    stats: "Estadísticas",
    setting: "configuración",
    module: "Módulos",
    control: "Pilotaje",
    light: "Claro",
    dark: "Oscuro",
    caption: {
      title: "Leyenda",
    },
    home_alert: {
      title: "Información",
      do_not_show_agin: "No volver a mostrar esta alerta",
    },
    entity: {
      contact: {
        title: ({ plural }) => plural(["Contacto", "Contactos"]),
      },
    },
    menu: {
      studea_manager_area: "Gestión de la promoción",
      admin_area: "Panel de administrador",
    },
    total: "Total",
    totalCompany: "Total a cargo del empleador (contribución obligatoria + resto a cargo)",
    table: {
      filtered_result: ({ plural }) => plural(["resultado filtrado", "resultados filtrados"]),
    },
    user: {
      activate: {
        success: "¡Usuario activado con éxito!",
      },
    },
    other: ({ plural }) => plural(["Otro", "Otros"]),
    data_table: {
      filtered_result: ({ plural, named }) =>
        plural([`(${named("count")} resultado filtrado)`, `(${named("count")} resultados filtrados)`]),
      filter_active: "(filtro activo)",
      select_all: "Seleccionar todo",
      select_line: "Seleccionar la fila",
      year: ({ named }) => `Año ${named("year")}`,
    },
    errors: "Error durante la regeneración",
    show_hide_caption: "Mostrar / Ocultar leyenda",
    title: "Leyenda",
    success: "¡Usuario activado con éxito!",
    expand: "Expandir",
    collapse: "Contraer",
    drag_to_reorder: "Arrastrar para reordenar",
    comments: "Comentarios",
    support: "Acceder al servicio de asistencia de STUDEA",
    new_window: "(abre en nueva ventana)",
    historic: {
      title: "Historial",
    },
    aria_label_separator: " — ",
  },
  breadcrumb: {
    home: "Inicio",
  },
  loading: "Cargando",
};
